import script from "./DefaultGroupCell.vue?vue&type=script&setup=true&lang=js"
export * from "./DefaultGroupCell.vue?vue&type=script&setup=true&lang=js"

import "./DefaultGroupCell.vue?vue&type=style&index=0&id=6c058565&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c058565"]])

export default __exports__